'use client'
import React, { useState, useEffect } from 'react'
import { Search, Eye, Users, Globe, AlertTriangle, CheckCircle, XCircle, Calendar, Shield, Activity, Ban } from 'lucide-react'
import { socket } from '../Containers/MainContainer'

function PlutoIPDet({ second_page }) {
  const [userProfile, setUserProfile] = useState({})
  const [earnings, setEarnings] = useState([0, 0, 0, 0, 0])
  const [page, setPage] = useState(1)
  const [pageNumber, setPageNumber] = useState(-1)
  const [userId, setUserId] = useState(0)
  const [canUse, setCanUse] = useState(true)
  const [username, setUsername] = useState('')
  const [users, setUsers] = useState([])
  const [ip, setIP] = useState({})
  const [rank, setRank] = useState(0)
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [sortBy, setSortBy] = useState('id')
  const [sortOrder, setSortOrder] = useState('asc')

  useEffect(() => {
    socket.on('response_get_admin_ipdetails', (data) => {
      setEarnings(data.withdrawals)
      setIP(data.ip)

      setPageNumber(Math.ceil(data.withdrawalsLength / 5))
      setUserProfile(data)
      setRank(data.rank)
    })

    socket.on('response_get_admin_ipdetails_users', (data) => {
      setUsers(data.users)
      setRank(data.rank)
      setLoading(false)
    })

    socket.on('response_get_admin_ipdetails_ip', (data) => {
      setIP(data.ip)
    })

    socket.emit('getIPDetailsAdmin', {
      ip: second_page,
    })

    socket.on('reTakeIpDet', () => {
      socket.emit('getIPDetailsAdmin', {
        ip: second_page,
      })
    })

    return () => {
      socket.off('response_get_admin_ipdetails')
      socket.off('response_get_admin_ipdetails_users')
      socket.off('response_get_admin_ipdetails_ip')
      socket.off('reTakeIpDet')
    }
  }, [second_page])

  // Filter and sort users
  const filteredUsers = users.filter(user =>
    user.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.id?.toString().includes(searchTerm) ||
    user.country?.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const sortedUsers = [...filteredUsers].sort((a, b) => {
    let aVal = a[sortBy]
    let bVal = b[sortBy]

    if (typeof aVal === 'string') {
      aVal = aVal.toLowerCase()
      bVal = bVal.toLowerCase()
    }

    if (sortOrder === 'asc') {
      return aVal > bVal ? 1 : -1
    } else {
      return aVal < bVal ? 1 : -1
    }
  })

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      setSortBy(column)
      setSortOrder('asc')
    }
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  }

  const handleBanIP = () => {
    socket.emit('adminAction', {
      action: 'ban_ip',
      ip: second_page,
    })
  }

  const getIPStatusBadge = (isBad) => {
    if (isBad === true) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#f85149' }}>
          <XCircle style={{ height: '16px', width: '16px' }} />
          <span>Banned</span>
        </div>
      )
    } else if (isBad === false) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#3fb950' }}>
          <CheckCircle style={{ height: '16px', width: '16px' }} />
          <span>Active</span>
        </div>
      )
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#8b949e' }}>
        <Activity style={{ height: '16px', width: '16px' }} />
        <span>Unknown</span>
      </div>
    )
  }

  const StatCard = ({ icon: Icon, title, value, color = "blue" }) => {
    const colorMap = {
      blue: { border: '#58a6ff', bg: 'rgba(88,166,255,0.15)', text: '#58a6ff' },
      green: { border: '#3fb950', bg: 'rgba(63,185,80,0.15)', text: '#3fb950' },
      red: { border: '#f85149', bg: 'rgba(248,81,73,0.15)', text: '#f85149' },
      purple: { border: '#a855f7', bg: 'rgba(168,85,247,0.15)', text: '#a855f7' },
    }
    const c = colorMap[color] || colorMap.blue
    return (
      <div style={{ background: '#161b22', borderRadius: '12px', padding: '16px', border: '1px solid #21262d', borderLeft: `3px solid ${c.border}` }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ padding: '8px', borderRadius: '8px', background: c.bg }}>
            <Icon style={{ height: '20px', width: '20px', color: c.text }} />
          </div>
          <div>
            <div style={{ fontSize: '11px', fontWeight: '600', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>{title}</div>
            <div style={{ fontSize: '20px', fontWeight: '700', color: '#e6edf3' }}>{value}</div>
          </div>
        </div>
      </div>
    )
  }

  const LoadingSkeleton = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} style={{ background: '#161b22', borderRadius: '8px', padding: '16px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '16px' }}>
            <div style={{ height: '16px', background: '#21262d', borderRadius: '4px' }}></div>
            <div style={{ height: '16px', background: '#21262d', borderRadius: '4px' }}></div>
            <div style={{ height: '16px', background: '#21262d', borderRadius: '4px' }}></div>
            <div style={{ height: '16px', background: '#21262d', borderRadius: '4px' }}></div>
            <div style={{ height: '16px', background: '#21262d', borderRadius: '4px' }}></div>
            <div style={{ height: '16px', background: '#21262d', borderRadius: '4px' }}></div>
          </div>
        </div>
      ))}
    </div>
  )

  return (
    <div style={{ minHeight: '100vh', background: '#0d1117', color: '#e6edf3' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '24px' }}>
        {/* Header */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
            <Globe style={{ height: '32px', width: '32px', color: '#58a6ff' }} />
            <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#e6edf3' }}>
              IP Address Details
            </h1>
          </div>
          <p style={{ color: '#8b949e' }}>
            Analysis for IP: <span style={{ color: '#58a6ff', fontFamily: 'monospace' }}>{second_page}</span>
          </p>
        </div>

        {/* IP Information Card */}
        <div style={{ background: '#161b22', borderRadius: '12px', border: '1px solid #21262d', marginBottom: '24px' }}>
          <div style={{ padding: '16px', borderBottom: '1px solid #21262d' }}>
            <h2 style={{ fontSize: '16px', fontWeight: '600', color: '#e6edf3', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Shield style={{ height: '20px', width: '20px', color: '#58a6ff' }} />
              IP Security Information
            </h2>
          </div>
          <div style={{ padding: '16px' }}>
            {loading && !ip.id ? (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px' }}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} style={{ background: '#21262d', borderRadius: '8px', height: '64px' }}></div>
                ))}
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px', marginBottom: '16px' }}>
                <div style={{ background: '#0d1117', borderRadius: '8px', padding: '12px' }}>
                  <div style={{ fontSize: '11px', color: '#8b949e', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>ID</div>
                  <div style={{ fontSize: '14px', fontFamily: 'monospace', color: '#e6edf3' }}>#{ip.id || 'N/A'}</div>
                </div>
                <div style={{ background: '#0d1117', borderRadius: '8px', padding: '12px' }}>
                  <div style={{ fontSize: '11px', color: '#8b949e', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Country</div>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#58a6ff' }}>{ip.country || 'N/A'}</div>
                </div>
                <div style={{ background: '#0d1117', borderRadius: '8px', padding: '12px' }}>
                  <div style={{ fontSize: '11px', color: '#8b949e', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>City</div>
                  <div style={{ fontSize: '14px', color: '#e6edf3' }}>{ip.city || 'N/A'}</div>
                </div>
                <div style={{ background: '#0d1117', borderRadius: '8px', padding: '12px' }}>
                  <div style={{ fontSize: '11px', color: '#8b949e', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Provider</div>
                  <div style={{ fontSize: '14px', color: '#e6edf3' }}>{ip.isp || 'N/A'}</div>
                </div>
                <div style={{ background: '#0d1117', borderRadius: '8px', padding: '12px' }}>
                  <div style={{ fontSize: '11px', color: '#8b949e', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Rejection</div>
                  <div style={{ fontSize: '14px', color: '#e6edf3' }}>{ip.rejection}</div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Stats Cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px', marginBottom: '24px' }}>
          <StatCard
            icon={Users}
            title="Total Users"
            value={users.length}
            color="blue"
          />
          <StatCard
            icon={Globe}
            title="Countries"
            value={[...new Set(users.map(u => u.country))].length}
            color="green"
          />
          <StatCard
            icon={Calendar}
            title="Active Users"
            value={users.length}
            color="purple"
          />
        </div>

        {/* Users Table */}
        <div style={{ background: '#161b22', borderRadius: '12px', border: '1px solid #21262d' }}>
          <div style={{ padding: '16px', borderBottom: '1px solid #21262d' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center', justifyContent: 'space-between' }}>
              <h2 style={{ fontSize: '16px', fontWeight: '600', color: '#e6edf3' }}>
                Users from IP: {second_page}
              </h2>
              <div style={{ position: 'relative', flex: '1', maxWidth: '400px', minWidth: '200px' }}>
                <Search style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', height: '16px', width: '16px', color: '#8b949e' }} />
                <input
                  type="text"
                  placeholder="Search by ID, username, or country..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    paddingLeft: '40px',
                    paddingRight: '16px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    width: '100%',
                    background: '#0d1117',
                    color: '#e6edf3',
                    borderRadius: '8px',
                    fontSize: '14px',
                    border: '1px solid #30363d',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e) => { e.target.style.borderColor = '#58a6ff' }}
                  onBlur={(e) => { e.target.style.borderColor = '#30363d' }}
                />
              </div>
            </div>
          </div>

          <div style={{ overflowX: 'auto' }}>
            {loading ? (
              <div style={{ padding: '16px' }}>
                <LoadingSkeleton />
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#161b22', borderBottom: '1px solid #21262d' }}>
                    {[
                      { key: 'id', label: 'ID' },
                      { key: 'username', label: 'USERNAME' },
                      { key: 'country', label: 'COUNTRY' },
                      { key: 'joinDate', label: 'JOIN DATE' },
                      { key: 'actions', label: 'ACTIONS' }
                    ].map((column) => (
                      <th
                        key={column.key}
                        style={{
                          padding: '12px 16px',
                          textAlign: 'left',
                          fontSize: '11px',
                          fontWeight: '600',
                          color: '#8b949e',
                          textTransform: 'uppercase',
                          letterSpacing: '0.8px',
                          cursor: column.key !== 'actions' ? 'pointer' : 'default',
                          borderBottom: '1px solid #21262d',
                          whiteSpace: 'nowrap'
                        }}
                        onClick={() => column.key !== 'actions' && handleSort(column.key)}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          {column.label}
                          {sortBy === column.key && (
                            <span style={{ color: '#58a6ff' }}>
                              {sortOrder === 'asc' ? ' ^' : ' v'}
                            </span>
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {sortedUsers.map((user) => (
                    <tr key={user.id} style={{ borderBottom: '1px solid #21262d', transition: 'background 0.15s' }}
                      onMouseOver={(e) => { e.currentTarget.style.background = 'rgba(33,38,45,0.5)' }}
                      onMouseOut={(e) => { e.currentTarget.style.background = 'transparent' }}
                    >
                      <td style={{ padding: '12px 16px', fontSize: '14px', fontFamily: 'monospace', color: '#c9d1d9' }}>
                        #{user.id}
                      </td>
                      <td style={{ padding: '12px 16px', fontSize: '14px' }}>
                        <div style={{ fontWeight: '500', color: '#e6edf3' }}>{user.username}</div>
                      </td>
                      <td style={{ padding: '12px 16px', fontSize: '14px', color: '#c9d1d9' }}>
                        <span style={{ fontSize: '12px', background: '#21262d', padding: '4px 8px', borderRadius: '4px', color: '#c9d1d9' }}>
                          {user.country}
                        </span>
                      </td>
                      <td style={{ padding: '12px 16px', fontSize: '14px', color: '#c9d1d9' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <Calendar style={{ height: '12px', width: '12px' }} />
                          {formatDate(user.joinDate)}
                        </div>
                      </td>
                      <td style={{ padding: '12px 16px', fontSize: '14px' }}>
                        <a
                          href={`/pluto/user/${user.id}`}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '6px 12px',
                            background: '#238636',
                            border: '1px solid #2ea043',
                            color: '#ffffff',
                            fontSize: '12px',
                            fontWeight: '600',
                            borderRadius: '6px',
                            textDecoration: 'none',
                            transition: 'background 0.15s',
                            cursor: 'pointer'
                          }}
                          onMouseOver={(e) => { e.target.style.background = '#2ea043' }}
                          onMouseOut={(e) => { e.target.style.background = '#238636' }}
                        >
                          <Eye style={{ height: '12px', width: '12px' }} />
                          Check User
                        </a>
                      </td>
                    </tr>
                  ))}
                  {sortedUsers.length === 0 && !loading && (
                    <tr>
                      <td colSpan="5" style={{ padding: '32px 16px', textAlign: 'center', color: '#484f58' }}>
                        No users found matching your search criteria
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Analysis Summary */}
        {!loading && users.length > 0 && (
          <div style={{ background: '#161b22', borderRadius: '12px', padding: '16px', border: '1px solid #21262d', marginTop: '24px' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#e6edf3', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AlertTriangle style={{ height: '20px', width: '20px', color: '#d29922' }} />
              IP Analysis Summary
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', fontSize: '14px' }}>
              <div>
                <span style={{ color: '#8b949e' }}>Countries detected:</span>
                <span style={{ marginLeft: '8px', color: '#e6edf3', fontWeight: '500' }}>
                  {[...new Set(users.map(u => u.country))].length}
                  {" "}({[...new Set(users.map(u => u.country))].join(', ')})
                </span>
              </div>
              <div>
                <span style={{ color: '#8b949e' }}>Registration span:</span>
                <span style={{ marginLeft: '8px', color: '#e6edf3', fontWeight: '500' }}>
                  {users.length > 0 && users.every(u => u.joinDate) &&
                    `${Math.ceil((new Date(Math.max(...users.map(u => new Date(u.joinDate)))) -
                      new Date(Math.min(...users.map(u => new Date(u.joinDate))))) / (1000 * 60 * 60 * 24))} days`
                  }
                </span>
              </div>
              <div>
                <span style={{ color: '#8b949e' }}>Risk Level:</span>
                <span style={{ marginLeft: '8px', color: '#e6edf3', fontWeight: '500' }}>
                  {ip.is_bad === true ? 'High Risk' : ip.is_bad === false ? 'Low Risk' : 'Unknown'}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PlutoIPDet
